import { render, staticRenderFns } from "./page-create-level.vue?vue&type=template&id=b2240134&"
import script from "./page-create-level.vue?vue&type=script&lang=ts&"
export * from "./page-create-level.vue?vue&type=script&lang=ts&"
import style0 from "./page-create-level.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports